import { CSSProperties } from "react";
import { ResourceType } from "~/business";
import { packBy, parseNumberOrError } from "~/utils";
import { XResourceType } from "./svg";
import { XResource } from "./XResource";
import { XStringWithNode } from "./XStringWithNode";
import { XTypography } from "./XTypography";

export const XResourceWithAmount = ({
  type,
  amount,
  amountStyle,
  style,
  width,
  variant = "compact",
}: {
  type: XResourceType;
  amount: string | number;
  amountStyle?: CSSProperties;
  style?: CSSProperties;
  width: number;
  variant?: "compact" | "separated";
}) => {
  const amountNumber =
    typeof amount === "string" ? parseNumberOrError(amount) : amount;

  if (variant === "separated") {
    return (
      <XStringWithNode string={amount.toString()} style={style}>
        <XResource width={width} type={type} />
      </XStringWithNode>
    );
  }

  if ([ResourceType.Water, "troop"].includes(type) && amountNumber) {
    const icons = [...new Array(amountNumber)].map((_, index) => (
      <XResource width={width} type={type} key={index} />
    ));
    const packs = packBy(icons, 2);
    return (
      <div>
        {packs.map((pack, index) => (
          <div key={index}>{pack}</div>
        ))}
      </div>
    );
  }
  return (
    <div
      style={{
        position: "relative",
        height: "fit-content",
        width: "fit-content",
        display: "inline-block",
        ...style,
      }}
    >
      <XResource width={width} type={type} />
      <XTypography
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: width * 0.6,
          color: "white",
          ...amountStyle,
        }}
      >
        {amount}
      </XTypography>
    </div>
  );
};
